"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextProvider = ContextProvider;
exports.Context = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Context = _react["default"].createContext({});

exports.Context = Context;

function ContextProvider(_ref) {
  var translate = _ref.translate,
      direction = _ref.direction,
      localizationData = _ref.localizationData,
      theme = _ref.theme,
      moment = _ref.moment,
      tenant = _ref.tenant,
      componentName = _ref.componentName,
      children = _ref.children;

  var value = _react["default"].useMemo(function () {
    return {
      translate: translate,
      direction: direction.toLowerCase(),
      localizationData: localizationData,
      theme: theme,
      moment: moment,
      tenant: tenant,
      componentName: componentName
    };
  }, [translate, direction, localizationData, theme, tenant, componentName]);

  return _react["default"].createElement(Context.Provider, {
    value: value
  }, children);
}